import * as angular from "angular";

angular
  .module('bringoz.admin.point-of-sale', []);
